import React, { useEffect, useState, useRef } from "react"
import MetaTags from "react-meta-tags"

import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Input,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  CardTitle,
  CardSubtitle,
  Alert,
} from "reactstrap"

import {
  AvForm,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation"

import Dropzone from "react-dropzone"

import classnames from "classnames"
import { Link } from "react-router-dom"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import "./styles.css"

// plastics auth service
import DisposalApplication from "../../services/DisposalApplication.service"

// Image Viewer
import ViewFiles from "components/Services/environment/en/ViewFiles"

import DecisionInfo from "components/Services/environment/en/DecisionInfo"
import General from "services/GeneralEndpoints"
import DisposalPreview from "components/Preview/Disposal.preview"

const STATIC_FILES = process.env.REACT_APP_STATIC_FILES
const BASE_URL = process.env.REACT_APP_BASE_URL

const user = JSON.parse(localStorage.getItem("authUser"))
const disposalApp = new DisposalApplication(user)
let generalService = new General(user)

const DisposalGuidance = props => {
  const [activeTab, setactiveTab] = useState(1)
  const [activeTabProgress, setactiveTabProgress] = useState(1)
  const [progressValue, setprogressValue] = useState(25)
  const [activeTabVartical, setoggleTabVertical] = useState(1)
  const [user, setuser] = useState()
  const [mounted, setmounted] = useState(false)
  const [productTypes, setproductTypes] = useState([])
  const [disposalReasons, setdisposalReasons] = useState([])
  const [isReturned, setisReturned] = useState(false)

  // disposal doc
  const [disposalDocument, setdisposalDocument] = useState()

  const [selectedFiles, setselectedFiles] = useState([])
  const [uploadedImages, setUploadedImages] = useState([])
  const [alreadySubmitted, setalreadySubmitted] = useState(false)
  const [uploadedFiles, setuploadedFiles] = useState([])

  const disposalFormRef = useRef(null)

  // form attributes
  const [applicationId, setapplicationId] = useState()
  const [loading, setloading] = useState(false)
  const [submitted, setsubmitted] = useState(false)
  const [error, seterror] = useState()
  const [applicationDetails, setApplicationDetails] = useState({})

  // submitted Application Details
  const [submittedApplication, setsubmittedApplication] = useState()
  const [subimttedFormData, setsubmittedFormData] = useState({})
  const [disableFormFields, setdisableFormFields] = useState(false)
  const [currentPath, setcurrentPath] = useState(
    window.location.pathname + props.location.search
  )
  const [showDecisionInfo, setshowDecisionInfo] = useState(false)
  const [decisionInfo, setDecisionInfo] = useState({})
  const [companies, setcompanies] = useState()
  const [companyId, setcompanyId] = useState()
  const [measures, setmeasures] = useState()
  const [measureId, setmeasureId] = useState("")
  const [applicationType, setApplicationType] = useState()

  const [disposalReasonsRaw, setdisposalReasonsRaw] = useState()
  const [productTypesRaw, setproductTypesRaw] = useState([])
  const [serviceAttachments, setserviceAttachments] = useState([])
  const [measuresRaw, setmeasuresRaw] = useState()
  const [editMode, seteditMode] = useState(false)

  const attachmentsFormRef = useRef(null)

  const [cancelUpload, setcancelUpload] = useState(false)

  useEffect(() => {
    //console.log(subimttedFormData)
    setcancelUpload(true)
  }, [subimttedFormData])

  useEffect(() => {
    const userObj = JSON.parse(localStorage.getItem("authUser"))
    setuser(userObj)
    fetchCompanies()
    fetchQuantityMeasures()
    fetchServiceAttachments()

    if (
      currentPath.includes("view-application") ||
      currentPath.includes("edit-application")
    ) {
      //show decision info card
      setshowDecisionInfo(true)
      setapplicationId(props.location.search.split("=")[1])

      

      disposalApp
        .getApplicationDetails(props.location.search.split("=")[1])
        .then(response => {
          console.log(response)
          if (response.status) {
            //check whether application status is return back to applicant
            //if return to applicant set edit mode to true

            setmeasureId(response.data.guidance_disposal.quantity_measure_id)

            if (response.data.application_status_id === 7) {
              setdisableFormFields(false)
              setisReturned(true)
              seteditMode(true)
            } else {
              setdisableFormFields(true)
            }
            if (response.data.guidance_disposal.company_id != null) {
              setApplicationType("company")
              setcompanyId(response.data.guidance_disposal.company_id)
            } else {
              setApplicationType("individual")
            }

            // set uploaded images
            setUploadedImages(response.data.application_attachments)
            console.log("attachments", response.data.application_attachments)

            setsubmittedFormData({
              company_name: response.data.guidance_disposal.company_name,
              company_representative:
                response.data.guidance_disposal.company_representative,
              contact_telephone:
                response.data.guidance_disposal.contact_telephone,
              tin: response.data.guidance_disposal.tin,
              location: response.data.guidance_disposal.location,
              quantity: response.data.guidance_disposal.quantity,
              disposal_product_type_id:
                response.data.guidance_disposal.disposal_product_type_id,
              disposal_reason_id:
                response.data.guidance_disposal.disposal_reason_id,
              description: response.data.guidance_disposal.description,
              chemical_composition:
                response.data.guidance_disposal.chemical_composition,
              origin_of_products:
                response.data.guidance_disposal.origin_of_products,
            })

            console.log(response.data)

            let comments = ""
            let certUrl = "#"
            if (response.data.application_status_id === 7) {
              // get comments from officer
              response.data.application_flow_histories.forEach(hist => {
                if (hist.application_status_id === 7) {
                  comments = hist.comment_to_applicant
                }
              })
            }

            if (response.data.application_status_id === 6) {
              // get certificate download url
              response.data.application_attachments.forEach(file => {
                if (file.description === "certificate") {
                  certUrl = STATIC_FILES + file.path
                }
              })
            }

            if (response.data.application_status_id === 6) {
              // get certificate download url
              certUrl = BASE_URL + "verify/certificate/" + response.data.app_id
            }

            // set decision info
            setDecisionInfo({
              statusId: response.data.application_status_id,
              status: response.data.application_status.name,
              service: response.data.service.name,
              comments: comments,
              certUrl: certUrl,
            })

            // set uploaded images
            // setUploadedImages({
            //   packageUrl:
            //     STATIC_FILES + response.data.application_attachments[0].path,
            //   productUrl:
            //     STATIC_FILES + response.data.application_attachments[1].path,
            // })
          }
        })
    } else {
      disposalApp.createApplication(userObj).then(response => {
        console.log(response)
        setapplicationId(response.data.id)
        seteditMode(true)
      })
    }

    // get product types
    disposalApp.getProductTypes().then(response => {
      const options = response.data.map((type, index) => (
        <option key={index} value={type.id}>
          {type.name}
        </option>
      ))
      setproductTypes(options)
      setproductTypesRaw(response.data)
      setmounted(true)
    })

    // get disposal reasons
    disposalApp.getDisposalReasons().then(response => {
      const options = response.data.map((type, index) => (
        <option key={index} value={type.id}>
          {type.name}
        </option>
      ))
      setdisposalReasons(options)
      setdisposalReasonsRaw(response.data)
      setmounted(true)
    })
  }, [])

  const fetchCompanies = () => {
    generalService.getCompanies().then(response => {
      console.log(response)
      if (response.status) {
        const comps = response.data.map((item, index) => {
          return (
            <option key={index} value={item.id}>
              {item.name}
            </option>
          )
        })

        setcompanies(comps)
      }
    })
  }

  const fetchQuantityMeasures = () => {
    generalService.getQuantityMeasures().then(response => {
      //console.log(response)
      if (response.status) {
        const meas = response.data.map((item, index) => {
          return (
            <option key={index} value={item.id}>
              {item.name}
            </option>
          )
        })

        setmeasures(meas)
        setmeasuresRaw(response.data)
      }
    })
  }

  const submitApplication = () => {
    disposalApp.bulkFileUpload(uploadedFiles)

    disposalApp
      .saveApplication({ ...applicationDetails, application_id: applicationId })
      .then(response => {
        console.log(response)
        setsubmitted(true)
        if (response.status) {
        } else {
          seterror("Error encountered while submitting application")
        }
      })
  }

  const validateApplicationDetails = formData => {
    // console.log(formData)
    let product_type_name = ""
    let measure_name = ""
    let reason_name = ""

    productTypesRaw.forEach(element => {
      if ("" + element.id + "" === formData.disposal_product_type_id) {
        product_type_name = element.name
      }
    })

    measuresRaw.forEach(element => {
      if ("" + element.id + "" === formData.quantity_measure_id) {
        measure_name = element.name
      }
    })

    disposalReasonsRaw.forEach(element => {
      if ("" + element.id + "" === formData.disposal_reason_id) {
        reason_name = element.name
      }
    })

    setApplicationDetails({
      ...formData,
      measure_name: measure_name,
      product_type_name: product_type_name,
      reason_name: reason_name,
    })
    setactiveTab(2)
  }

  const onChangeDisposalDocument = event => {
    setdisposalDocument(event.target.files[0])
  }

  const validateFiles = () => {
    if (disableFormFields) {
      return
    }
    if (disposalDocument === undefined) {
      alert("Upload all required files")
      return
    } else {
      setactiveTab(3)
    }
  }

  function toggleTab(tab) {
    if (activeTab !== tab) {
      if (tab >= 1 && tab <= 3) {
        setactiveTab(tab)
      }
    }
  }

  const fetchServiceAttachments = () => {
    // get service attachments
    disposalApp.getServiceAttachments().then(response => {
      console.log("service attachemnts", response)
      if (response.status) {
        const attachments = response.data.map((attachment, index) => (
          <Row key={index}>
            <span>{attachment.description}</span>
            <input
              type="file"
              //onChange={onChangeProductImage}
              id={attachment.name}
              required={attachment.is_mandatory}
              accept=".pdf,image/*"
            />
          </Row>
        ))
        setserviceAttachments(attachments)
      }
    })
  }

  const prepareUploadFiles = e => {
    let current_attachments = []
    let kount = 0
    for (kount = 0; kount < serviceAttachments.length; kount++) {
      if (e.target[kount].files.length > 0) {
        current_attachments.push({
          application_id: applicationId,
          description: e.target[kount].id,
          file: e.target[kount].files[0],
        })
      }
    }
    setuploadedFiles(current_attachments)
    console.log(current_attachments)
    setactiveTab(3)
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Apply | Guidance</title>
        </MetaTags>
        <Container fluid={true}>
          <Breadcrumbs
            maintitle="Dashboard"
            title="Application"
            breadcrumbItem="Guidance"
          />

          {showDecisionInfo ? (
            <Row>
              <Col sm="12">
                <DecisionInfo data={decisionInfo} />
              </Col>
            </Row>
          ) : (
            ""
          )}

          {!submitted ? (
            <Row>
              <Col sm="12">
                <Card>
                  <CardBody>
                    <h4 className="card-title mb-4">
                      Guidance on disposal of various products
                    </h4>
                    <div className="form-horizontal form-wizard-wrapper wizard clearfix">
                      <div className="steps clearfix">
                        <ul>
                          <NavItem
                            className={classnames({ current: activeTab === 1 })}
                          >
                            <NavLink
                              className={classnames({
                                current: activeTab === 1,
                              })}
                              onClick={() => {
                                //setactiveTab(1)
                              }}
                            >
                              <span className="number">1.</span> Application
                              Details
                            </NavLink>
                          </NavItem>
                          <NavItem
                            className={classnames({ current: activeTab === 2 })}
                          >
                            <NavLink
                              className={classnames({
                                active: activeTab === 2,
                              })}
                              onClick={() => {
                                //setactiveTab(2)
                              }}
                            >
                              <span className="number">2.</span> Document
                              Uploads
                            </NavLink>
                          </NavItem>

                          <NavItem
                            className={classnames({ current: activeTab === 3 })}
                          >
                            <NavLink
                              className={classnames({
                                active: activeTab === 3,
                              })}
                              onClick={() => {
                                //setactiveTab(3)
                              }}
                            >
                              <span className="number">3.</span>
                              Confirm Detail
                            </NavLink>
                          </NavItem>
                        </ul>
                      </div>
                      <div className="content clearfix">
                        <TabContent activeTab={activeTab} className="body">
                          <TabPane tabId={1}>
                            <AvForm
                              onValidSubmit={(e, v) => {
                                validateApplicationDetails(v)
                              }}
                              model={subimttedFormData}
                            >
                              {error ? (
                                <Alert color="danger">{error}</Alert>
                              ) : null}
                              <Row>
                                <Col md={4}>
                                  <Row className="mb-3">
                                    <div>
                                      <AvField
                                        type="select"
                                        name="application_type"
                                        label="Select Application Type"
                                        value={applicationType}
                                        required
                                        disabled={disableFormFields}
                                        onChange={e => {
                                          setApplicationType(e.target.value)
                                        }}
                                      >
                                        <option value="">--select--</option>
                                        <option value="company">Company</option>
                                        <option value="individual">
                                          Individual
                                        </option>
                                      </AvField>
                                    </div>
                                  </Row>
                                </Col>

                                {applicationType === "individual" ? (
                                  <Col md={4}>
                                    <Row className="mb-3">
                                      <div>
                                        <AvField
                                          type="text"
                                          name="tin"
                                          label="Identification Number"
                                          value={
                                            subimttedFormData.tin
                                              ? subimttedFormData.tin
                                              : ""
                                          }
                                          required
                                          disabled={disableFormFields}
                                        />
                                      </div>
                                    </Row>
                                  </Col>
                                ) : (
                                  <Col md="4">
                                    {applicationType === "company" ? (
                                      <>
                                        <Row>
                                          <AvField
                                            type="select"
                                            name="company_id"
                                            label="Select Company"
                                            required
                                            value={companyId}
                                            disabled={disableFormFields}
                                          >
                                            <option>--Select Company</option>
                                            {companies}
                                          </AvField>
                                        </Row>
                                      </>
                                    ) : null}
                                  </Col>
                                )}
                                <Col md={4}>
                                  <Row className="mb-3">
                                    <AvField
                                      type="select"
                                      name="disposal_product_type_id"
                                      label="Select Product Type"
                                      value={
                                        subimttedFormData.disposal_product_type_id
                                          ? subimttedFormData.disposal_product_type_id
                                          : ""
                                      }
                                      // required
                                      disabled={disableFormFields}
                                    >
                                      <option value="">--select--</option>
                                      {productTypes}
                                    </AvField>
                                  </Row>
                                </Col>
                              </Row>

                              <Row>
                                <Col md={4}>
                                  <Row className="mb-3">
                                    <AvField
                                      name="quantity"
                                      type="number"
                                      className="form-control"
                                      label="Quantity of Product"
                                      value={
                                        subimttedFormData.quantity
                                          ? subimttedFormData.quantity
                                          : ""
                                      }
                                      required
                                      disabled={disableFormFields}
                                    />
                                  </Row>
                                </Col>
                                <Col md={4}>
                                  <Row className="mb-3">
                                    <AvField
                                      type="select"
                                      name="quantity_measure_id"
                                      label="Quantity measure"
                                      required
                                      value={measureId}
                                      disabled={disableFormFields}
                                    >
                                      <option value="">--select--</option>
                                      {measures}
                                    </AvField>
                                  </Row>
                                </Col>
                                <Col md={4}>
                                  <Row className="mb-3">
                                    <AvField
                                      name="chemical_composition"
                                      type="text"
                                      className="form-control"
                                      label="Chemical Composition"
                                      value={
                                        subimttedFormData.chemical_composition
                                          ? subimttedFormData.chemical_composition
                                          : ""
                                      }
                                      required
                                      disabled={disableFormFields}
                                    />
                                  </Row>
                                </Col>
                              </Row>

                              <Row>
                                <Col md={4}>
                                  <Row className="mb-3">
                                    <AvField
                                      type="select"
                                      name="disposal_reason_id"
                                      label="Reason for disposal"
                                      value={
                                        subimttedFormData.disposal_reason_id
                                          ? subimttedFormData.disposal_reason_id
                                          : ""
                                      }
                                      required
                                      disabled={disableFormFields}
                                    >
                                      <option value="">--select--</option>
                                      {disposalReasons}
                                    </AvField>
                                  </Row>
                                </Col>
                                <Col md={4}>
                                  <Row className="mb-3">
                                    <AvField
                                      name="origin_of_products"
                                      type="text"
                                      className="form-control"
                                      label="Origin of Products"
                                      value={
                                        subimttedFormData.origin_of_products
                                          ? subimttedFormData.origin_of_products
                                          : ""
                                      }
                                      required
                                      disabled={disableFormFields}
                                    />
                                  </Row>
                                </Col>
                                <Col md={4}>
                                  <Row className="mb-3">
                                    <AvField
                                      name="location"
                                      type="text"
                                      className="form-control"
                                      label="Location"
                                      value={
                                        subimttedFormData.location
                                          ? subimttedFormData.location
                                          : ""
                                      }
                                      required
                                      disabled={disableFormFields}
                                    />
                                  </Row>
                                </Col>
                              </Row>

                              <Row></Row>

                              <Row>
                                <AvField
                                  disabled={disableFormFields}
                                  type="textarea"
                                  label="Product Description"
                                  value={
                                    subimttedFormData.description
                                      ? subimttedFormData.description
                                      : ""
                                  }
                                  id="description"
                                  name="description"
                                  rows="4"
                                  placeholder="Enter product description here!"
                                  className="form-control"
                                  required
                                ></AvField>
                              </Row>

                              <Row style={{ display: "none" }}>
                                <Col md={12}>
                                  <button
                                    ref={disposalFormRef}
                                    onClick={() => {
                                      // props.onHide()
                                      // setmodal(false)
                                    }}
                                    type="submit"
                                    style={{ float: "right", fontSize: 18 }}
                                    className="btn btn-primary col-3"
                                    disabled={loading}
                                  >
                                    Next
                                  </button>
                                </Col>
                              </Row>
                            </AvForm>
                          </TabPane>
                          <TabPane tabId={2}>
                            <Row>
                              <Col className="col-12">
                                <Card>
                                  <CardBody>
                                    <CardTitle className="h4">
                                      Document Upload
                                    </CardTitle>
                                   
                                    {disableFormFields ? <ViewFiles attachments={uploadedImages} /> : (
                                      // <ViewFiles data={uploadedImgages} />
                                      <div className="mb-5">
                                        <AvForm
                                          onValidSubmit={(e, v) =>
                                            prepareUploadFiles(e)
                                          }
                                        >
                                          <Row>
                                            <Col md={12}>
                                              {serviceAttachments}
                                            </Col>
                                          </Row>

                                          <Row style={{ display: "none" }}>
                                            <Col md={12}>
                                              <button
                                                ref={attachmentsFormRef}
                                                type="submit"
                                              >
                                                Upload Attachments
                                              </button>
                                            </Col>
                                          </Row>
                                        </AvForm>
                                      </div>
                                    )}
                                  </CardBody>
                                </Card>
                              </Col>
                            </Row>
                          </TabPane>
                          <TabPane tabId={3}>
                            <div className="row justify-content-center">
                              <Col lg="6">
                                <div className="text-center">
                                  <div className="mb-4">
                                    <i className="mdi mdi-check-circle-outline text-success display-4" />
                                  </div>
                                  <div>
                                    <h5>Proceed to submit Application</h5>
                                  </div>
                                </div>
                              </Col>
                            </div>
                            {editMode ? (
                              <DisposalPreview data={applicationDetails} />
                            ) : null}
                          </TabPane>
                        </TabContent>
                      </div>
                      <div className="actions clearfix">
                        <ul>
                          <li
                            className={
                              activeTab === 1 ? "previous disabled" : "previous"
                            }
                          >
                            <Link
                              to={currentPath}
                              className="btn btn-primary"
                              onClick={() => {
                                toggleTab(activeTab - 1)
                              }}
                            >
                              Previous
                            </Link>
                          </li>
                          <li
                            className={
                              activeTab === 3 ? "next disabled" : "next"
                            }
                          >
                            <Link
                              to={currentPath}
                              className="btn btn-primary"
                              onClick={() => {
                                if (activeTab === 1) {
                                  disposalFormRef.current.click()
                                } else if (activeTab === 2) {
                                  if (!disableFormFields) {
                                    if (!cancelUpload) {
                                      attachmentsFormRef.current.click()
                                    } else if (isFreshApplication) {
                                      attachmentsFormRef.current.click()
                                    } else if (!showDocuments) {
                                      attachmentsFormRef.current.click()
                                    } else {
                                      toggleTab(3)
                                    }
                                  }
                                } else {
                                  toggleTab(activeTab + 1)
                                }
                              }}
                            >
                              Next
                            </Link>
                          </li>
                          {activeTab === 3 ? (
                            <li style={{ float: "right" }}>
                              <Link
                                to="#"
                                className="btn btn-primary"
                                onClick={() => {
                                  submitApplication()
                                }}
                                disabled={disableFormFields}
                              >
                                Submit
                              </Link>
                            </li>
                          ) : (
                            ""
                          )}
                        </ul>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          ) : (
            <Row>
              <Card>
                <CardBody>
                  <div className="row justify-content-center">
                    <Col lg="6">
                      <div className="text-center">
                        <div className="mb-4">
                          <i className="mdi mdi-check-circle-outline text-success display-4" />
                        </div>
                        <div>
                          <h5>Application succesfully submitted</h5>
                        </div>
                        <>
                          <Link
                            to="/dashboard"
                            className="btn btn-primary"
                            onClick={() => {
                              toggleTab(activeTab + 1)
                            }}
                          >
                            Back
                          </Link>
                        </>
                      </div>
                    </Col>
                  </div>
                </CardBody>
              </Card>
            </Row>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

export default DisposalGuidance
